module.exports = __webpack_public_path__ + "h.no1.7726e5c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/h.no1.jpg
// module id = iuD4
// module chunks = 0